import { render, staticRenderFns } from "./DepartmentRoles.vue?vue&type=template&id=0cec6db6"
import script from "./DepartmentRoles.vue?vue&type=script&lang=ts"
export * from "./DepartmentRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports